import { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { metaServices } from "../../../APIServices/VoultManagement/metaServices";

const FormPreview = ({
    fieldList,
}) => {
    const [showPasswordMap, setShowPasswordMap] = useState({});
    const [bankList, setBankList] = useState([]);
    const [DBList, setDBList] = useState([]);
    const [cardList, setCardList] = useState([]);
    const [storageList, setStorageList] = useState([]);
    const [fileList, setFileList] = useState([]);

    const toggleShowPassword = (id) => {
        setShowPasswordMap((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const getBankMetadataList = async () => {
        let data = await metaServices.getMetadataList(
            "active",
            "bankaccount",
        );
        setBankList(data?.data || []);
    };
    const getCardMetadataList = async () => {
        let data = await metaServices.getMetadataList(
            "active",
            "creditdebit",
        );
        setCardList(data?.data || []);
    };
    const getDBMetadataList = async () => {
        let data = await metaServices.getMetadataList(
            "active",
            "database",
        );
        setDBList(data?.data || []);
    };
    const getStorageMetadataList = async () => {
        let data = await metaServices.getMetadataList(
            "active",
            "storage",
        );
        setStorageList(data?.data || []);
    };
    const getFileMetadataList = async () => {
        let data = await metaServices.getMetadataList(
            "active",
            "file",
        );
        setFileList(data?.data || []);
    };

    useEffect(() => {
        if (fieldList?.some(item => item.optionId === "bankaccount")) {
            getBankMetadataList();
        }
        if (fieldList?.some(item => item.optionId === "creditdebit")) {
            getCardMetadataList();
        }
        if (fieldList?.some(item => item.optionId === "database")) {
            getDBMetadataList();
        }
        if (fieldList?.some(item => item.optionId === "storage")) {
            getStorageMetadataList();
        }
        if (fieldList?.some(item => item.optionId === "file")) {
            getFileMetadataList();
        }
    }, [fieldList]);

    return (
        <>
            <div className="bg-light border px-4 py-2">
                {fieldList?.map(field => (
                    <Form.Group key={field.id} className="mb-2">
                        <Form.Label className={`mb-1 fw-bold`} style={{ fontSize: 13 }}>
                            {field.label}{" "}
                            {field?.require &&
                                <abbr className="text-danger" title="Require">
                                    *
                                </abbr>
                            }
                        </Form.Label>
                        {field.type === "textarea" ?
                            <Form.Control
                                as="textarea"
                                rows={3}
                                className="interactive-input"
                                placeholder={field?.placeholder || "Write here..."}
                                style={{ fontSize: 12, padding: "26px 15px 10px" }}
                            />
                            : field.type === "select" ?
                                <Form.Select
                                    className="interactive-input"
                                    style={{ fontSize: 12, padding: "6px 15px" }}
                                >
                                    <option value="">{field?.placeholder}</option>
                                    {(field?.optionId === "bankaccount" ? bankList
                                        : field?.optionId === "creditdebit" ? cardList
                                            : field?.optionId === "database" ? DBList
                                                : field?.optionId === "file" ? fileList
                                                    : field?.optionId === "storage" ? storageList
                                                        : field?.optionId === "custom" ? field?.options
                                                            : []
                                    )?.map((option, index) => (
                                        <option key={index} value={option?.key}>{option?.name}</option>
                                    ))}
                                </Form.Select>
                                : field.type === "password" ?
                                    <InputGroup key={field.id} className="mb-2">
                                        <Form.Control
                                            type={showPasswordMap[field.id] ? "text" : "password"}
                                            className="interactive-input"
                                            style={{ fontSize: 12, padding: "6px 15px" }}
                                            placeholder={field?.placeholder}
                                        />
                                        <InputGroup.Text
                                            style={{ cursor: "pointer" }}
                                            onClick={() => toggleShowPassword(field.id)}
                                        >
                                            {showPasswordMap[field.id] ? <FaEyeSlash /> : <FaEye />}
                                        </InputGroup.Text>
                                    </InputGroup>
                                    :
                                    <Form.Control
                                        type={field.type}
                                        className="interactive-input"
                                        style={{ fontSize: 12, padding: "6px 15px" }}
                                        placeholder={field?.placeholder}
                                    />
                        }
                    </Form.Group>
                ))}
            </div>
        </>

    );
};

export default FormPreview;
